<p>{{ meetingID ? "Meeting updated" : "Attendance recorded" }}</p>
